export const toFiniteNumberOrNull = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export const degreesToRise = (degrees) => {
  const value = toFiniteNumberOrNull(degrees);
  if (value === null) return null;
  return Math.tan((value * Math.PI) / 180) * 12;
};

export const riseToDegrees = (rise) => {
  const value = toFiniteNumberOrNull(rise);
  if (value === null) return null;
  return Math.atan(value / 12) * (180 / Math.PI);
};

export const parseRiseRun = (text) => {
  if (text === null || text === undefined) return null;
  const value = String(text).trim();
  if (!value) return null;
  const match = value.match(/^(-?\d+(?:\.\d+)?)(?:\s*\/\s*12)?$/);
  if (!match) return null;
  return toFiniteNumberOrNull(match[1]);
};

export const formatRiseRun = (degrees) => {
  const rise = degreesToRise(degrees);
  if (rise === null) return '';

  const roundedInteger = Math.round(rise);
  const isInteger = Math.abs(rise - roundedInteger) < 0.05;
  const formattedRise = isInteger
    ? String(roundedInteger)
    : String(Math.round(rise * 10) / 10);
  return `${formattedRise}/12`;
};
